module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAkUlEQVRYR+1UsQ2AMAxzLgA+ZGlnuATmZuFEekFQUakKYisSi7O6clwnseDnkp/7gwLoQHHAOTcCWPJSzqq61Qt64SLStyyume0ACn8R4L1PQJfI0yNVHepGNd4i4Mn/KgBADCHcfvqlgJr/NgIRWbPC6W0EGT9daqhoZoWfV0AHmAPMAV4BHWAOMAd4BXSADhw9XashLirzcwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list.png
// module id = 729
// module chunks = 8